import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router";
import axios from "axios";
import "../../Styles/Components/Persons/PersonList.css";
import {useNavigate } from "react-router-dom";
import Dialog_alert from "../PublicForms/Dialog_alert.js";
import LoaderComp from "../PublicForms/Loader.js";
import Config from "../PublicForms/Config.js";
import isTokenExpired from "../PublicForms/isTokenExpired.js";
import Navigation_Bar from "../PublicForms/Navigation_Bar.js";
import Header from "../PublicForms/Header.js";
import iconRemove from '../../Images/iconRemove.png';


const SubDetailsLst = ()=>
{
    const[loading, setLoading] = useState(false);
    const[runUseEffect, setRunUseEffect] = useState(true);
    const[runChkActive, setRunChkActive] = useState(false);
    const[runUseDelete, setRunUseDelete] = useState(false);
    const[message, setMessage] = useState([]);
    const[messTitle, setMessTitle] = useState("");
    const[subDetailsLst, setSubDetailsLst] = useState([]);
    const[showDialog, setShowDialog] = useState(false);
    const[previewShow, setPreviewShow]= useState(false); 
    const[pages, setPages] = useState();
    const[runPagination, setRunPagination] = useState(false);
    const[page, setPage] = useState(1);
    const[pagesList, setPagesList] = useState([]);
    const[which, setWhich]= useState("Add");
    const[detailsID, setDetailsID] = useState(0);
    const[searchDate, setSearchDate] = useState("");
    const[width, setWidth] = useState(0);
    const{personID}  = useParams();
    const[openNav, setOpenNav] = useState(false);

    var count = 0;
    const Navigate = useNavigate();
    const prevPageRef = useRef();
    const pageSize = 10;
    prevPageRef.current = 1;

    useEffect(() => {
        if (localStorage.getItem('token')) {
          const token = localStorage.getItem('token');
          if (isTokenExpired(token)) {
            localStorage.removeItem('token');
            Navigate("/login");
        } else {
            // setUser(JSON.parse(localStorage.getItem('user')));
          }
        } else {
            Navigate("/login");
        }
      }, []);

      useEffect(() => {
        function handleResize() {
          setWidth(window.innerWidth)
        }
        
        window.addEventListener("resize", handleResize)
        
        handleResize()
        
        
      }, []);

    const handleNave = ()=>
    {
        setOpenNav(!openNav);

    }

   
    const handleNaveForm = ()=>
    {
        if(!openNav)
        {
            setOpenNav(!openNav)
        }
    }


   const closeOpenDialog = (open) =>
    {
          setMessage([]);
          setShowDialog(false);
            
    }
 
    useEffect(()=>
    {
        
        const checkActive = async () => {
            setLoading(true);
            setMessage([]);
            axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/${personID}/false?chkActive=true`,{headers: {
         
                "Authorization":`Bearer ${localStorage.getItem('token')}`,
              }
            }).then(response => 
            {
                if(response.data === false)
                {
                    setPreviewShow(true);
                    setWhich("Add");
                                            
                }else
                {
                setMessTitle("توجه");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        "شما قادر به ایجاد حساب اشتراک جدید نیستید، فرد مورد نظر حساب فعال دارد.",      // append new element
                    ];
                });
                setShowDialog(true);
                }
    
            }).catch((err) =>{
    
                if(err.response !== null && err.response !== undefined)
                {
                    setMessage([]);
                    if(err.response.status === 401)
                    {
                        Navigate("/login");
                    }else if((err.response.status) === 500)
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                (err.response.detail),      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                    }else
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
            
                    }
        
                }else if(err.message == "Network Error")
                {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                        ];
                    });
                    setShowDialog(true);
                }else
                {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        ("لطفا مجددا تلاش کنید"),      // append new element
                    ];
                });                
                
                setShowDialog(true);
                }
                
            })
            setLoading(false);
            setRunChkActive(false);

        }

        if(runChkActive === true)
        {
            checkActive();
            

        }

    },[runChkActive])


    useEffect(()=>
    {
        const fetchSubDetailsPages = async () => {
            setLoading(true);
            axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/${personID}/false`,{headers: {
         
                "Authorization":`Bearer ${localStorage.getItem('token')}`,
              }
            }).then(response => 
            {
            if(response.status === 200)
            {
                var resp = Math.ceil(response.data.length/pageSize);
                setPages(response.data.length/pageSize);
                if(!runPagination)
                    {
                        if (resp <= 4 && resp >0) {
                            for (let i = 1; i <= resp; i++) {
                                pagesList.push(i);
                            }
                            }else if(resp>4) 
                            {
                            for (let i = 1; i <= 4; i++) {
                                pagesList.push(i);
                            }
                            }
                    }
                        fetchSubDetailsList();
                                        
            }else
            {
            setMessTitle("خطا");
            setMessage((prevMessages) => {
                return [
                    ...prevMessages, // shallow copy into new array reference
                    ("لطفا مجددا تلاش کنید"),      // append new element
                ];
            });
            setShowDialog(true);
            }

            }).catch((err) =>{

                if(err.response !== null && err.response !== undefined)
                    {
                        setMessage([]);
                        if(err.response.status === 401)
                        {
                            Navigate("/login");
                        }else if((err.response.status) === 500)
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    (err.response.detail),      // append new element
                                ];
                            });
                            setShowDialog(true);
            
                        }else
                        {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "لطفا مجددا تلاش کنید",      // append new element
                                ];
                            });
                            setShowDialog(true);
                
                        }
            
                    }else if(err.message == "Network Error")
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
                    }else
                    {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            ("لطفا مجددا تلاش کنید"),      // append new element
                        ];
                    });                
                    
                    setShowDialog(true);
                    }
            })
            
        }
        const fetchSubDetailsList = async () => {

            axios.get(`${Config.apiBaseUrl}/api/SubscriptDetails/${personID}/false?date=${searchDate}&PageSize=${pageSize}&PageNumber=${page-1}`,{headers: {
         
                "Authorization":`Bearer ${localStorage.getItem('token')}`,
              }
            }).then(response => 
                {
                if(response.status === 200)
                {
                    setSubDetailsLst(response.data);
                                            
                }else
                {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        ("لطفا مجددا تلاش کنید"),      // append new element
                    ];
                });
                setShowDialog(true);
                }

            }).catch((err) =>{

                if(err.response !== null && err.response !== undefined)
                {
                    setMessage([]);
                    if(err.response.status === 401)
                    {
                        Navigate("/login");
                    }else if((err.response.status) === 500)
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                (err.response.detail),      // append new element
                            ];
                        });
                        setShowDialog(true);
        
                    }else
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
            
                    }
        
                }else if(err.message == "Network Error")
                {
                    setMessTitle("خطا");
                    setMessage((prevMessages) => {
                        return [
                            ...prevMessages, // shallow copy into new array reference
                            "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                        ];
                    });
                    setShowDialog(true);
                }else
                {
                setMessTitle("خطا");
                setMessage((prevMessages) => {
                    return [
                        ...prevMessages, // shallow copy into new array reference
                        ("لطفا مجددا تلاش کنید"),      // append new element
                    ];
                });                
                
                setShowDialog(true);
                }
            })
            setRunUseEffect(false);
            setLoading(false);
        }

        if(runUseEffect === true)
        {
            fetchSubDetailsPages();

            if(runPagination)
            {

                if (pages <= 4 && pages >0) {
                    for (let i = 1; i <= pages; i++) {
                        pagesList.push(i);
                    }
                } else 
                {
                    if (page == 1 || page == 2) {
                        for (let i = 1; i <= 4; i++) {
                        pagesList.push(i);
                        }
                    } else if (page > 2 && page <= pages - 2) {
                        for (let i = page - 2; i <= page + 2; i++) {
                        pagesList.push(i);
                        }
                    } else if (page > pages - 2 && page != pages) {
                        for (let i = page - 2; i <= pages; i++) {
                        pagesList.push(i);
                        }
                    } else if (page == pages-1) {
                        for (let i = page - 3; i <= pages; i++) {
                        pagesList.push(i);
                        }
                    }else if(page == pages)
                    {
                        for(let i = page - 4; i<= pages; i++)
                        {
                            pagesList.push(i);
                        }
                    }
                    
                }
            }
                

        }

    },[runUseEffect])

    useEffect(()=>
        {
            const deleteData = async ()=>
            {
                axios.delete(
                    `${Config.apiBaseUrl}/api/SubscriptDetails/${detailsID}`,{headers: {
                
                    "Authorization":`Bearer ${localStorage.getItem('token')}`,
                    }
                }).then(response => 
                {
                    if(response.status == 204)
                    {
                        setMessTitle("توجه");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "اطلاعات مورد نظر شما با موفقیت حذف شد",      // append new element
                            ];
                            });
                        setShowDialog(true);
                        setRunUseEffect(true);
            
                    }else
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "لطفا مجددا تلاش کنید",      // append new element
                            ];
                        });
                        setShowDialog(true);
                    }
            
                }).catch((err) =>{
                    
                    if(err.response !== null && err.response !== undefined)
                    {
                        setMessage([]);
                        if(err.response.status == 401)
                        {
                            Navigate("/login");
            
            
                        }else if((err.response.status) === 400)
                        {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                    ...prevMessages, // shallow copy into new array reference
                                    ("اطلاعات این کاربر قبلا حذف شده است."),      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                        }else
                        {
                                setMessTitle("خطا");
                                setMessage((prevMessages) => {
                                    return [
                                    ...prevMessages, // shallow copy into new array reference
                                    "لطفا مجددا تلاش کنید",      // append new element
                                    ];
                                });
                                setShowDialog(true);
                
                        }
                
                    }else if(err.message == "Network Error")
                    {
                        setMessTitle("خطا");
                        setMessage((prevMessages) => {
                            return [
                                ...prevMessages, // shallow copy into new array reference
                                "برقراری ارتباط با سرور امکان پذیر نمی باشد",      // append new element
                            ];
                        });
                        setShowDialog(true);
                    }else
                    {
                            setMessTitle("خطا");
                            setMessage((prevMessages) => {
                                return [
                                    ...prevMessages, // shallow copy into new array reference
                                    ("لطفا مجددا تلاش کنید"),      // append new element
                                ];
                            });                
                            
                            setShowDialog(true);
                    }      
                })
            }
    
            if(runUseDelete)
            {
                deleteData();
            }
    
        },[runUseDelete]);
    

    const changePage = (pageNum, pagesNum) => {
        setRunUseEffect(true);
        setRunPagination(true);
        setPage(pageNum);
        setPagesList([]);
    
       
      }
   
    
   

    if(width>999)
    {
        if(loading)
            {
                return(<div className="personLst">
                            <p className="personLst-loader-txt"> لطفا چند لحظه صبر کنید...</p>   
                        <div className="personLst-loader">
                            <LoaderComp />
                        </div>
                    
                    </div>)
            }else
            {
                return(
        
                    <div className="personLst-all">
                        <Header />
        
                            
                        <div className="navClass">
                                <Navigation_Bar />
                            
                        </div>
                            
                       <div className="personLst">
                        <div className="row personLst-top-page">
                           {/* <div className="col-sm-8 form-group">
                            
                               <DatePicker
                                 
                                  value={searchDate}
                                  calendar={persian}
                                  locale={persian_fa}
                                  calendarPosition="bottom-right"
                                  onChange = { e => searchSet(e)}
                                  placeholder="جستجو براساس تاریخ شروع..."
                                />
                           </div>     
                        {previewShow ? <Preview_SubDetails show = {previewShow} closeOpenAdd = {closeOpenAdd} which = {which} personID = {personID} detailsID = {detailsID} /> : null} */}
                        {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                         
        
                               <div className="table-responsive-sm personLst-tbl">
                                    <div className="table-responsive">
                        
                                            <table className="table table-condensed">
                                                <thead>
                            
                                                    <tr>
                                                        <td>ردیف</td>
                                                        <td>تاریخ شروع</td>
                                                        <td>طول دوره</td>
                                                        <td>پرداختی</td>
                                                        <td>موجودی</td>
                                                        <td></td>
                                                    </tr>
                            
                                                </thead>
                                                
                                                <tbody>
                                                {
                                                    subDetailsLst.map((lst, i)=>
                                                    {
                                                                            
                                                        count = count+1;
                                                                                        
                                                        return(
                                                            <tr key={lst.detailsID}
                                                            onClick={()=>{
                                                                setDetailsID(lst.detailsID);
                                                                setPreviewShow(true);
                                                                setWhich("Edit");
                                
                                                            }}
                                                            > 
                                                                <td onClick={()=>{

                                                                   Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)

                                                                }}>{i+(pageSize*(page-1))+1}</td>
                                                                <td onClick={()=>{

                                                                Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)

                                                                }}>{lst.startDate}</td>
                                                                <td onClick={()=>{

                                                                Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)

                                                                }}>{lst.detailsDuration}</td>
                                                                <td onClick={()=>{

                                                                Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)

                                                                }}>{lst.total}</td>
                                                                <td  onClick={()=>{

                                                                Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)

                                                                }}>{lst.remainAmount}</td>
                                                                <td className="tbl-details" onClick={()=> {
                                                                setDetailsID(lst.detailsID);
                                                                setRunUseDelete(true);
                                                                setShowDialog(true);
        
        
                                                                }}><img className="subRecImg" src={iconRemove}/></td>
                                                                                                                                
                                                            
                                                            </tr>
                                                        )          
                                                        
                                                    }
                                                    
                                                    )
                                                }
                                                </tbody>
                                                
                                            </table>
                                            {/* pagination */}
                                            <div
                                                style={{
                                                
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    marginTop: "5%",
                                                }}
                                                >
                                                <nav aria-label="Page navigation" style={{
                                                
                                                }}>
                                                    <ul className="pagination" >
                                                    <li key= "next" className="page-item">
                                                        <a
                                                        key = {999999999}
                                                        id={page < pages ? page + 1 : page}
                                                        className="page-link"
                                                        href="#"
                                                        aria-label="Next"
                                                        onClick={() =>
                                                            page < pages ? changePage(page + 1, pages) : null
                                                        }
                                                        
                                                        >
                                                        <span
                                                            aria-hidden="true"
                                                            style={page == 1 ? { color: "grey" } : null}
                                                        >
                                                        &laquo;
        
                                                        </span>
                                                        <span className="sr-only">Next</span>
                                                        </a>
                                                    </li>
                                                    {pagesList.slice(0).reverse().map((pageList,index) => {
                                                        return (
                                                        <li
                                                            key={index}
                                                            className="page-item"
                                                            onClick={() => changePage(pageList, pages)}
                                                        >
                                                            <a
                                                            id={pageList}
                                                            className={
                                                                pageList == page ? "page-link active" : "page-link"
                                                            }
                                                            href="#"
                                                            >
                                                            {pageList}
                                                            </a>
                                                        </li>
                                                        );
                                                    })}
                                                    <li key= {0} className="page-item">
                                                        <a
                                                            id={page > 1 ? page - 1 : page}
                                                            className="page-link"
                                                            href="#"
                                                            aria-label="Previous"
                                                            onClick={() =>
                                                                page > 1 ? changePage(page - 1, pages) : null
                                                            }
                                                        >
                                                        <span
                                                            aria-hidden="true"
                                                            style={pages == page ? { color: "grey" } : null}
                                                        >
                                                            &raquo;
        
                                                        </span>
                                                        <span className="sr-only">prev</span>
                                                        </a>
                                                    </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                    </div>
                
        
                                </div>  
                          <div/>
        
                        </div>
                            
                        </div>
        
                    </div>
            
                );
            }
    }else
    {
        if(loading)
            {
                return(<div className="personLst">
                            <p className="personLst-loader-txt"> لطفا چند لحظه صبر کنید...</p>   
                        <div className="personLst-loader">
                            <LoaderComp />
                        </div>
                    
                    </div>)
            }else
            {
                return(

                    <div className="personLst-all-responsive">
                       
                          
                        <div className= {openNav? "navClass" : "navClass navClassOpen"}>
                            

                            <Navigation_Bar />
                            
                        </div>
                        
            
                        <div className="personLst-all">
                            <Header handleNave={handleNave}/>
            
                           
                        <div className="personLst" onClick={()=>handleNaveForm()}>
                            <div className="row personLst-top-page">
                            {/* <div className="col-md-4 form-group">
                                
                                <DatePicker
                                    
                                    value={searchDate}
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    onChange = { e => searchSet(e)}
                                    placeholder="جستجو براساس تاریخ شروع..."
                                    />
                            </div>     
                            {previewShow ? <Preview_SubDetails show = {previewShow} closeOpenAdd = {closeOpenAdd} which = {which} personID = {personID} detailsID = {detailsID} /> : null} */}
                            {showDialog ? <Dialog_alert show = {showDialog} closeOpenDialog = {closeOpenDialog} messTitle ={messTitle} message = {message}/> : null}
                            
            
                                <div className="table-responsive-sm personLst-tbl">
                                        <div className="table-responsive">
                            
                                                <table className="table table-condensed">
                                                    <thead>
                                
                                                        <tr>
                                                            <td>ردیف</td>
                                                            <td>تاریخ شروع</td>
                                                            <td>طول دوره</td>
                                                            <td>پرداختی</td>
                                                            <td>موجودی</td>
                                                            <td></td>
                                                        </tr>
                                
                                                    </thead>
                                                    
                                                    <tbody>
                                                    {
                                                        subDetailsLst.map((lst, i)=>
                                                        {
                                                                                
                                                            count = count+1;
                                                                                            
                                                            return(
                                                                <tr key={lst.detailsID}
                                                                onClick={()=>{
                                                                    setDetailsID(lst.detailsID);
                                                                    setPreviewShow(true);
                                                                    setWhich("Edit");
                                    
                                                                }}
                                                                > 
                                                                    <td onClick={()=>{
    
                                                                       Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)
    
                                                                    }}>{i+(pageSize*(page-1))+1}</td>
                                                                    <td onClick={()=>{
    
                                                                    Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)
    
                                                                    }}>{lst.startDate}</td>
                                                                    <td onClick={()=>{
    
                                                                    Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)
    
                                                                    }}>{lst.detailsDuration}</td>
                                                                    <td onClick={()=>{
    
                                                                    Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)
    
                                                                    }}>{lst.total}</td>
                                                                    <td  onClick={()=>{
    
                                                                    Navigate(`/subscripts/previewSubscript/اشتراک/newSubScript/${lst.personID}/${lst.detailsID}/true/false`)
    
                                                                    }}>{lst.remainAmount}</td>
                                                                    <td className="tbl-details" onClick={()=> {
                                                                    setDetailsID(lst.detailsID);
                                                                    setRunUseDelete(true);
                                                                    setShowDialog(true);
            
            
                                                                    }}><img className="subRecImg" src={iconRemove}/></td>
                                                                                                                                    
                                                                
                                                                </tr>
                                                            )           
                                                            
                                                        }
                                                        
                                                        )
                                                    }
                                                    </tbody>
                                                    
                                                </table>
                                                {/* pagination */}
                                                <div
                                                    style={{
                                                    
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        marginTop: "5%",
                                                    }}
                                                    >
                                                    <nav aria-label="Page navigation" style={{
                                                    
                                                    }}>
                                                        <ul className="pagination" >
                                                        <li key= "next" className="page-item">
                                                            <a
                                                            key = {999999999}
                                                            id={page < pages ? page + 1 : page}
                                                            className="page-item"
                                                            href="#"
                                                            aria-label="Next"
                                                            onClick={() =>
                                                                page < pages ? changePage(page + 1, pages) : null
                                                            }
                                                            
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={page == 1 ? { color: "grey" } : null}
                                                            >
                                                                &laquo;

                                                            </span>
                                                            <span className="sr-only">Next</span>
                                                            </a>
                                                        </li>
                                                        {pagesList.slice(0).reverse().map((pageList,index) => {
                                                            return (
                                                            <li
                                                                key={index}
                                                                className="page-item"
                                                                onClick={() => changePage(pageList, pages)}
                                                            >
                                                                <a
                                                                id={pageList}
                                                                className={
                                                                    pageList == page ? "page-link active" : "page-link"
                                                                }
                                                                href="#"
                                                                >
                                                                {pageList}
                                                                </a>
                                                            </li>
                                                            );
                                                        })}
                                                        <li key= {0} className="page-item">
                                                            <a
                                                                id={page > 1 ? page - 1 : page}
                                                                className="page-item"
                                                                href="#"
                                                                aria-label="Previous"
                                                                onClick={() =>
                                                                    page > 1 ? changePage(page - 1, pages) : null
                                                                }
                                                            >
                                                            <span
                                                                aria-hidden="true"
                                                                style={pages == page ? { color: "grey" } : null}
                                                            >
                                                                &raquo;


                                                            </span>
                                                            <span className="sr-only">prev</span>
                                                            </a>
                                                        </li>
                                                        </ul>
                                                    </nav>
                                                </div>
                                        </div>
                    
            
                                    </div>  
            
                            </div>
                                
                            </div>
            
                        </div>

                    </div>
            
                );
            }
    }

    
   
}

export default SubDetailsLst;
